import { DocGenerationPage } from '@/pages/docs/DocGenerationPage'
import PageLoading from '@/components/PageLoading'
import { createFileRoute } from '@tanstack/react-router'

// Create the documentation topic route with path-based navigation
export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/generate/doc'
)({
  // validateSearch: (search) => searchSchema.parse(search),
  component: DocGenerationPage,
  pendingComponent: () => (
    <div className='w-screen'>
      <PageLoading />
    </div>
  ),
  pendingMs: 0,
  pendingMinMs: 200,
})
